(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wh-review"] && !Shopify.designMode) return;
  try {
    (() => {
    'use strict';
    if (window.WellHomeReviewMore) return;

    /*
      "Leer más" en las opiniones que no caben en las 4 lineas del diseno.

      El boton lo enciende el JS, no Liquid: si el texto desborda depende del ancho de la
      tarjeta y de la fuente. Se compara `scrollHeight` con `clientHeight`, que es la unica
      forma fiable de saber si `-webkit-line-clamp` esta recortando algo de verdad.

      Se recalcula al cambiar el tamano de la ventana y cuando terminan de cargar las
      fuentes: con la fuente de reserva el mismo texto puede ocupar tres lineas y con la
      definitiva cinco, asi que medir antes de tiempo enciende o apaga botones al azar.
    */
    const MARGEN = 2; // px de tolerancia: el redondeo del navegador da diferencias de 1 px

    const revisar = (root) => {
      (root || document).querySelectorAll('[data-review-body]').forEach((cuerpo) => {
        const boton = cuerpo.parentElement && cuerpo.parentElement.querySelector('[data-review-more]');
        if (!boton) return;
        if (boton.getAttribute('aria-expanded') === 'true') return; // desplegada: no se toca
        boton.hidden = cuerpo.scrollHeight - cuerpo.clientHeight <= MARGEN;
      });
    };

    const LINEAS = 4;      // las mismas que recorta el CSS
    const DURACION = 420;  // ms; el mismo valor que la transicion, para el plan B

    /*
      `-webkit-line-clamp` NO es animable, asi que se anima `height` entre dos valores en
      pixeles. Las alturas se calculan aqui y no en CSS porque dependen del texto.

      El reflujo forzado (`void cuerpo.offsetHeight`) no es un adorno: sin el, el navegador
      agrupa las dos escrituras de `height` en un solo estilo calculado, no hay dos valores
      que interpolar y el despliegue vuelve a ser instantaneo. Se usa reflujo en vez de
      `requestAnimationFrame` porque es sincrono y no depende de que la pestana este
      visible: con rAF, en una pestana de fondo la animacion no arranca.
    */
    const animar = (cuerpo, abrir) => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        cuerpo.classList.toggle('is-open', abrir);
        return;
      }
      const lineaAlto = parseFloat(getComputedStyle(cuerpo).lineHeight) || 27;
      const desde = cuerpo.getBoundingClientRect().height;

      cuerpo.classList.add('is-animando');
      cuerpo.style.height = desde + 'px';
      void cuerpo.offsetHeight;

      cuerpo.classList.toggle('is-open', abrir);
      const hasta = abrir ? cuerpo.scrollHeight : Math.round(lineaAlto * LINEAS);
      cuerpo.style.height = hasta + 'px';

      let hecho = false;
      const limpiar = () => {
        if (hecho) return;
        hecho = true;
        cuerpo.style.height = '';
        cuerpo.classList.remove('is-animando');
        cuerpo.removeEventListener('transitionend', alTerminar);
      };
      // `transitionend` no llega si la transicion no llega a arrancar (altura identica,
      // pestana oculta, animaciones desactivadas en el sistema). Sin plan B, la tarjeta se
      // quedaria con una altura fija en pixeles para siempre.
      const alTerminar = (evento) => { if (evento.propertyName === 'height') limpiar(); };
      cuerpo.addEventListener('transitionend', alTerminar);
      setTimeout(limpiar, DURACION + 120);
    };

    document.addEventListener('click', (evento) => {
      const boton = evento.target.closest('[data-review-more]');
      if (!boton) return;
      const cuerpo = document.getElementById(boton.getAttribute('aria-controls'));
      if (!cuerpo) return;
      const abierta = boton.getAttribute('aria-expanded') === 'true';
      animar(cuerpo, !abierta);
      boton.setAttribute('aria-expanded', String(!abierta));
      boton.textContent = abierta ? boton.dataset.labelMore : boton.dataset.labelLess;
    });

    window.addEventListener('resize', () => revisar(), { passive: true });
    document.addEventListener('shopify:section:load', (evento) => revisar(evento.target));
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => revisar());

    window.WellHomeReviewMore = { revisar };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => revisar(), { once: true });
    } else {
      revisar();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
